import React from 'react'

const Relevance = () => {
  return (
    <div>Relevance</div>
  )
}

export default Relevance